import { ProgressBar, Spinner } from 'react-bootstrap';
import {
  useCentrifugeProgress,
  type CentrifugeProgressMessage
} from '@/hooks/useCentrifugeProgress';

export const DEFAULT_SOCKET_PROGRESS_DESCRIPTION =
  'در حال دریافت اطلاعات، لطفا منتظر بمانید...';

type SocketProgressBarProps = {
  channelId: string;
  active: boolean;
  onComplete?: (data: CentrifugeProgressMessage) => void;
  onProgress?: (data: CentrifugeProgressMessage) => void;
  className?: string;
  description?: string;
  /** Shown until the first live socket message. Used after a page reload. */
  initialPercentage?: number;
};

const SocketProgressBar = ({
  channelId,
  active,
  onComplete,
  onProgress,
  className = 'mb-3',
  description = DEFAULT_SOCKET_PROGRESS_DESCRIPTION,
  initialPercentage
}: SocketProgressBarProps) => {
  const { connected, progressData, progressPercentage, isComplete } =
    useCentrifugeProgress({
      channelId,
      active,
      onComplete,
      onProgress
    });
  const shown = progressData ? progressPercentage : (initialPercentage ?? 0);

  if (!active || isComplete) return null;
  if (!connected) return null;

  return (
    <div className={className}>
      <div className="rounded bg-body-tertiary shadow-sm p-2">
        {description && (
          <div className="mb-2" style={{ fontSize: '14px' }}>
            {description}
          </div>
        )}
        <div className="d-flex gap-1 align-items-center">
          <Spinner
            style={{
              width: '20px',
              height: '20px',
              marginBottom: '-3px',
              paddingLeft: '3px'
            }}
            className="me-2"
          />
          <div className="w-100">
            <div className="mb-1" style={{ fontSize: '14px' }}>
              <span className="float-end">{shown}%</span>
            </div>
            <ProgressBar
              now={shown}
              max={100}
              style={{ height: 5 }}
              className="rounded-pill align-middle"
              variant="success"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocketProgressBar;
